/* The Dopest Vault — global theme JS.
   Ported 1:1 from the Next.js behaviors:
   · ScrollReveal (fail-visible reveal: probe → arm html.js-reveal → IO → MutationObserver → sweep backstop)
   · useDialog (cart drawer: open/close, ESC, scrim, html+body scroll lock with scrollbar compensation, focus trap, focus restore)
   Page-level behaviors (hero carousel, deal parallax, PDP, AJAX cart) load in Phase 3. */
(function () {
  "use strict";

  /* ─────────────────────────────────────────────────────────────────────
     Fail-visible scroll reveal
     ───────────────────────────────────────────────────────────────────── */
  (function scrollReveal() {
    var html = document.documentElement;
    var pending = new Set();
    var armed = false;
    var io = null;

    function reveal(el) {
      el.classList.add("is-in");
      pending.delete(el);
    }
    function collect(root) {
      var out = [];
      if (root.nodeType !== 1) return out;
      if (root.matches && root.matches("[data-reveal]")) out.push(root);
      if (root.querySelectorAll) root.querySelectorAll("[data-reveal]").forEach(function (n) { out.push(n); });
      return out;
    }
    function arm(els) {
      if (armed) return;
      armed = true;
      html.classList.add("js-reveal");
      io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); }
        });
      }, { rootMargin: "0px 0px -8% 0px", threshold: 0.02 });
      els.forEach(function (el) {
        el.style.transitionDelay = (parseInt(el.dataset.reveal || "0", 10) || 0) + "ms";
        pending.add(el);
        io.observe(el);
      });
      sweep();
    }
    function sweep() {
      var vh = window.innerHeight || 800;
      pending.forEach(function (el) {
        if (!el.isConnected) { pending.delete(el); if (io) io.unobserve(el); return; }
        if (el.getBoundingClientRect().top < vh) reveal(el);
      });
    }
    function adopt(els) {
      if (!els.length) return;
      if (!armed) { arm(els); return; }
      els.forEach(function (el) {
        if (pending.has(el) || el.classList.contains("is-in")) return;
        el.style.transitionDelay = (parseInt(el.dataset.reveal || "0", 10) || 0) + "ms";
        pending.add(el);
        io.observe(el);
      });
      sweep();
    }

    function start() {
      if (!("IntersectionObserver" in window)) return; // fail-visible: content stays visible
      var initial = collect(document.body);
      // Probe: only arm once IntersectionObserver has provably fired.
      var probe = new IntersectionObserver(function (entries, obs) {
        obs.disconnect();
        arm(initial.length ? initial : collect(document.body));
      });
      probe.observe(document.body);
      var mo = new MutationObserver(function (muts) {
        var fresh = [];
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) { collect(n).forEach(function (e) { fresh.push(e); }); });
        });
        adopt(fresh);
      });
      mo.observe(document.body, { childList: true, subtree: true });
      window.addEventListener("scroll", sweep, { passive: true });
      window.addEventListener("resize", sweep, { passive: true });
    }
    // 90ms after load, matching the source probe timing.
    setTimeout(start, 90);
  })();

  /* ─────────────────────────────────────────────────────────────────────
     Cart drawer — open/close, scroll lock, focus (ported from useDialog)
     ───────────────────────────────────────────────────────────────────── */
  (function cartDrawer() {
    var drawer = document.getElementById("CartDrawer");
    if (!drawer) return;
    var panel = drawer.querySelector(".td-drawer__panel");
    var restore = null;
    var prev = {};
    var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

    function lock() {
      var el = document.documentElement;
      prev = { html: el.style.overflow, body: document.body.style.overflow, pad: document.body.style.paddingRight };
      var gutter = window.innerWidth - el.clientWidth;
      el.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      if (gutter > 0) document.body.style.paddingRight = gutter + "px";
    }
    function unlock() {
      document.documentElement.style.overflow = prev.html || "";
      document.body.style.overflow = prev.body || "";
      document.body.style.paddingRight = prev.pad || "";
    }
    function focusables() {
      return Array.prototype.slice.call(panel.querySelectorAll(FOCUSABLE)).filter(function (n) { return n.offsetParent !== null; });
    }
    function onKey(e) {
      if (e.key === "Escape") { e.stopPropagation(); close(); return; }
      if (e.key !== "Tab") return;
      var els = focusables();
      if (!els.length) { e.preventDefault(); panel.focus(); return; }
      var first = els[0], last = els[els.length - 1], active = document.activeElement;
      if (e.shiftKey) { if (active === first || !panel.contains(active)) { e.preventDefault(); last.focus(); } }
      else { if (active === last || !panel.contains(active)) { e.preventDefault(); first.focus(); } }
    }
    function open() {
      if (!drawer.hidden) return;
      restore = document.activeElement;
      drawer.hidden = false;
      drawer.setAttribute("data-open", "");
      lock();
      var f = focusables();
      (f[0] || panel).focus({ preventScroll: true });
      document.addEventListener("keydown", onKey, true);
    }
    function close() {
      if (drawer.hidden) return;
      drawer.hidden = true;
      drawer.removeAttribute("data-open");
      unlock();
      document.removeEventListener("keydown", onKey, true);
      if (restore && restore.focus) restore.focus({ preventScroll: true });
    }

    document.addEventListener("click", function (e) {
      if (e.target.closest("[data-cart-toggle]")) { e.preventDefault(); open(); }
      else if (e.target.closest("[data-cart-close]")) { e.preventDefault(); close(); }
    });

    window.DopestCart = { open: open, close: close };
  })();
})();
